import { FC, ReactNode, useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import styles from './Card.module.scss';

type CardProps = {
  to: string;
  addClass?: string[];
  children: ReactNode;
};
export const Card: FC<CardProps> = ({ to, addClass = [], children }) => {
  const navigate = useNavigate();
  const handleClick = useCallback(() => {
    navigate(to);
  }, [navigate, to]);
  return (
    <button type="button" className={[styles.card, ...addClass].join(' ')} onClick={handleClick}>
      {children}
    </button>
  );
};
